export const mapQueryParams = <T = Record<string, string>>(query: string): T =>
  Object.fromEntries(query.split(/[& | ?]/).map((value) => value.split('=')));

export const decodeQueryParams = <T = Record<string, string>>(
  query: string = '',
) => {
  const decoded = Buffer.from(query, 'base64').toString('utf-8');
  return mapQueryParams<T>(decoded);
};
